import React from 'react';
import { View } from 'react-native';
import { Text } from '@shared/components/text';
import Icon from '@shared/components/md-design-system/Icon/Icon';
import Button from '@shared/components/md-design-system/Button/Button';
import { colorPalette } from '@shared/config/colorsConfig';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';
import { getFormattedTimestamp } from '@shared/utils/date';

interface Props {
    isCancelled: boolean;
    createdAt: string;
    canCancel: boolean;
    requestId: string;
    onRequestCancel?: (requestId: string) => void;
    isCancelling?: boolean;
    onView?: () => void;
}

export const TeleassistancePendingContent: React.FC<Props> = ({
    isCancelled,
    createdAt,
    canCancel,
    requestId,
    onRequestCancel,
    isCancelling = false,
    onView,
}) => {
    const { t } = dynamicTranslations();
    const s = 'teleassistance.card';

    return (
        <>
            <View className="flex-row items-center gap-3 mb-2">
                <View className={`w-8 h-8 rounded-full justify-center items-center ${isCancelled ? 'bg-gray-200' : 'bg-primary-100'}`}>
                    <Icon
                        name={isCancelled ? 'close' : 'calendar'}
                        size={16}
                        color={isCancelled ? colorPalette.gray[500] : colorPalette.primary[700]}
                    />
                </View>
                <Text className={`font-semibold text-base ${isCancelled ? 'text-gray-500' : 'text-gray-900'}`}>
                    {isCancelled ? t(`${s}.cancelledTitle`) : t(`${s}.pendingTitle`)}
                </Text>
            </View>
            <Text className="text-sm text-gray-600">
                {t(`${s}.pendingDescription`, { date: getFormattedTimestamp(createdAt) })}
            </Text>
            {!isCancelled && (onView || (canCancel && onRequestCancel)) && (
                <View className="flex-row gap-2">
                    {onView && (
                        <View className="flex-1">
                            <Button variant="primary" icon="eye" onPress={onView}>
                                {t('appointments.card.viewButton')}
                            </Button>
                        </View>
                    )}
                    {canCancel && onRequestCancel && (
                        <View className="flex-1">
                            <Button
                                icon="delete"
                                variant="danger-outline"
                                onPress={() => onRequestCancel(requestId)}
                                disabled={isCancelling}
                            >
                                {t(`${s}.deleteButton`)}
                            </Button>
                        </View>
                    )}
                </View>
            )}
        </>
    );
};
